import { useTranslation } from 'react-i18next';

import Checkbox from '@/components/Checkbox';

type Props = {
  readonly isChecked?: boolean;
  readonly onChange: (checked: boolean) => void;
};

const TogglePassword = ({ isChecked, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <Checkbox name="toggle-password" checked={isChecked} onChange={onChange}>
      <span className="text-sm text-foreground">{t('action.show_password')}</span>
    </Checkbox>
  );
};

export default TogglePassword;
